import api from '../../js/api.js';
import { notify } from '../msgbox.js';
import { REGEX, replaceIndex } from '../table.js';

// Campo GTIN na conferência: bip → embalagem (+ produto se vazio).
// Não usar observer no próprio campo: hook() roda antes de register() e locate falha.
export default function ()
{
	const SHARED = { _this: null };
	return {
		captureEvents(_this = this)
		{
			this.safeProtoCall(_this);
			this.subscribe(['change'], this._onPackagingGtinChange.bind(this), false);
		},

		async preventMultiCalls(object, primary_callback, secondary_callback, ...args)
		{
			const el = document.querySelector(this.selector);
			const is_datalist_indexed = el && REGEX.test(el.getAttribute('list') || '');
			const is_action_ongoing = Boolean(object._this);
			if (!is_datalist_indexed && is_action_ongoing)
			{
				object._this.subscribe(['done'], secondary_callback);
			}
			else
			{
				object._this = this;
				await primary_callback(...args);
				if (!is_datalist_indexed)
					object._this.publish('done', ...args);
				object._this = null;
			}
		},

		async _onPackagingGtinChange(_event_name, _publisher, value)
		{
			const action = async () =>
			{
				const raw = (value != null && value !== '' ? String(value) : (this.getValue() || '')).trim();
				if (!raw)
					return;
				const company_id = this.locate('company_id')?.getValue();
				if (!company_id)
					return;
				const pack = await api.call(api.resolve_packaging_gtin, company_id, raw);
				if (!pack)
					return;
				const prodSel = this.makeId('product_id-0');
				const pidField = this.locate(prodSel);
				const cur = pidField?.getValue();
				if (cur != null && cur !== '' && Number(cur) !== Number(pack.product_id)) {
					notify('Este GTIN pertence a outro produto. Ajuste o produto ou o código bipado.', 'Conferência');
					return;
				}
				if (pidField && (cur == null || cur === '')) {
					pidField.setValue(pack.product_id);
					pidField.refresh();
				}
				const ppack = this.locate(this.makeId('product_packaging_id-0'));
				if (ppack) {
					ppack.setValue(pack.id);
					ppack.refresh();
				}
			};
			await this.preventMultiCalls(SHARED, action, () => this.refresh(), []);
		},

		makeId(name)
		{
			const parts = this.getId().match(/([^.]+\.)([^-]+)(-\d+)?/);
			const form = parts[1];
			const index = parts[3];
			if (name.match(REGEX))
				name = replaceIndex(name, index.substr(1));
			return form + name;
		},
	};
}
